import { UUID } from "crypto";
import { useState } from "react";

interface Telephone {
  id: number;
  uid: UUID;
  telephone: string;
  primary: boolean;
  deletedAt: string | null;
}
const useTelephoneMenuActions = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [currentTelephoneForMenu, setCurrentTelephoneForMenu] =
    useState<Telephone | null>(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    telephone: Telephone
  ) => {
    setAnchorEl(event.currentTarget);
    setCurrentTelephoneForMenu(telephone);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentTelephoneForMenu(null);
  };

  return {
    anchorEl,
    openMenu,
    currentTelephoneForMenu,
    handleMenuClick,
    handleMenuClose,
  };
};

export default useTelephoneMenuActions;
